module.exports = __webpack_public_path__ + "static/img/1825_phase_function_Paper_Points.4b3cb98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1825_phase_function_Paper_Points.png
// module id = fECZ
// module chunks = 0